var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ce-login-main-wrapper"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"ce-login-wrapper"},[_c('div',{staticClass:"ce-login-sec"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }